/* eslint-disable camelcase */
const axios = require('axios');

const API_URL = process.env.REACT_APP_API_URL;
const API_KEY = process.env.REACT_APP_API_KEY;
const header = {
  'Content-Type': 'application/json',
  'x-metro-api-key': API_KEY,
};

async function autoLogout(err) {
  if (err.response
    && err.response.data
    && err.response.data.error
    && err.response.data.error.code === 1004) {
    localStorage.removeItem('admin-panel-sessionToken');
    window.location.reload();
  }
}

function get(url, params = {}) {
  const header = { 'Content-Type': 'application/json', 'x-metro-api-key': API_KEY };
  return axios.get(
    API_URL + url, { headers: header, params, withCredentials: true },
  ).then((resp) => resp)
    .catch((err) => {
      autoLogout(err);
      throw err;
    });
}

function post(url, params = {}) {
  const header = { 'Content-Type': 'application/json', 'x-metro-api-key': API_KEY };
  return axios.post(
    API_URL + url, params, { headers: header, withCredentials: true },
  ).then((resp) => resp)
    .catch((err) => {
      autoLogout(err);
      throw err;
    });
}

function sess_get(url, sessiontoken, params) {
  const header = { 'Content-Type': 'application/json', 'x-metro-api-key': API_KEY, 'x-metro-sessiontoken': sessiontoken };
  return axios.get(
    API_URL + url, { headers: header, params, withCredentials: true },
  ).then((resp) => resp)
    .catch((err) => {
      autoLogout(err);
      throw err;
    });
}

function sess_post(url, sessiontoken, params) {
  const header = { 'Content-Type': 'application/json', 'x-metro-api-key': API_KEY, 'x-metro-sessiontoken': sessiontoken };
  return axios.post(
    API_URL + url, params, { headers: header, withCredentials: true },
  ).then((resp) => resp)
    .catch((err) => {
      autoLogout(err);
      throw err;
    });
}

function sess_put(url, sessiontoken, params) {
  const header = { 'Content-Type': 'application/json', 'x-metro-api-key': API_KEY, 'x-metro-sessiontoken': sessiontoken };
  return axios.put(
    API_URL + url, params, { headers: header, withCredentials: true },
  ).then((resp) => resp)
    .catch((err) => {
      autoLogout(err);
      throw err;
    });
}

function sess_delete(url, sessiontoken, params) {
  const header = { 'Content-Type': 'application/json', 'x-metro-api-key': API_KEY, 'x-metro-sessiontoken': sessiontoken };
  return axios.delete(
    API_URL + url, { data: params, headers: header, withCredentials: true },
  ).then((resp) => resp)
    .catch((err) => {
      autoLogout(err);
      throw err;
    });
}

function checkForToken() {
  window.checkIsLogin && window.checkIsLogin();
  if (
    localStorage.getItem('admin-panel-sessionToken') &&
    localStorage.getItem('admin-panel-sessionToken') !== ''
  ) {
    header['x-metro-sessiontoken'] = localStorage.getItem(
      'admin-panel-sessionToken'
    );
  }
}

function sessionExpired(err) {
  if (
    err.response &&
    err.response.data &&
    err.response.data.error &&
    err.response.data.error.code === 1004
  ) {
    localStorage.clear();
    sessionStorage.clear();
    window.location.reload();
  }
}

function GET(url, params = {}) {
  checkForToken();
  return axios
    .get(url, { headers: header, params: params, withCredentials: true })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      // sessionExpired(err);
      throw err;
    });
}

function POST(url, params = {}) {
  checkForToken();
  return axios
    .post(url, params, { headers: header, withCredentials: true })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      // sessionExpired(err);
      throw err;
    });
}

function PUT(url, params, updates, abc = {}) {
  checkForToken();
  return axios
    .put(url, updates, { headers: { ...header, ...abc }, params: params, withCredentials: true })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      sessionExpired(err);
      throw err;
    });
}

function DELETE(url, params) {
  checkForToken();
  return axios
    .delete(url, { headers: header, params: params, withCredentials: true })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      sessionExpired(err);
      throw err;
    });
}



function setup_axios_interceptor(store) {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const { data } = error.response;
      if (data && data.error.code === 2046) {
        store.dispatch({
          type: 'LOGOUT',
        });
        window.location.href = '/';
        localStorage.clear();
      }
      return Promise.reject(error);
    },
  );
}

export {
  get,
  post,
  sess_get,
  sess_post,
  sess_put,
  sess_delete,
  setup_axios_interceptor,
  GET,
  POST,
  PUT,
  DELETE
};
